function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 179.63,
  y1: 214.11,
  x2: 198.53,
  y2: 184.02,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff8e31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ed6b21"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 112.89,
  y1: 232.57,
  x2: 134.65,
  y2: 208.4,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "13_Authentication_isometric");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M343.25,175.31,188,265.14a21.22,21.22,0,0,1-21.2,0L57.7,202.51a9.65,9.65,0,0,1,0-16.73L220,92.05l123.1,68.41A8.53,8.53,0,0,1,343.25,175.31Z",
  fill: "#ff8e31"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M171.8,163.41l-43.28,26.07s55,31.52,76.43,44.25l44.92-25.44",
  fill: "url(#linear-gradient)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M131.46,192.45,88.19,218.51S101.62,227.32,123,240l45.81-28.13",
  fill: "url(#linear-gradient-2)"
});

var _ref7 = /*#__PURE__*/React.createElement("polyline", {
  points: "138.56 161.02 138.56 163.97 140.06 165.81",
  fill: "#adcee1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M198,125l-57.74,35.78a3.58,3.58,0,0,0,.12,6.16L228,216.51a8,8,0,0,0,8-.07l57.47-33.79c4.18-3.43,3.86-9.89,0-10.16l-87.1-47.62A8.14,8.14,0,0,0,198,125Z",
  fill: "#88d3d8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M198,122.55l-57.74,35.78a3.58,3.58,0,0,0,.12,6.16L228,214a8,8,0,0,0,8-.07l57.47-33.79a4.45,4.45,0,0,0,0-7.7l-87.1-50.09A8.14,8.14,0,0,0,198,122.55Z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M200.35,117.66s24-77.38,23.83-77.38.75-3.44,5-1.5l92,54.16s4.46,1.81,3.59,6-23.44,75.72-23.44,75.72a3.89,3.89,0,0,1-4.35,1.5c-2.8-.87-94.52-54.15-94.52-54.15A3.52,3.52,0,0,1,200.35,117.66Z",
  fill: "#053855"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "225.7 45.9 319.93 100.83 300.38 166.44 204.95 113.14 225.7 45.9",
  fill: "#e1a621"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M194.45,130.75,173.34,143.9a2.55,2.55,0,0,0,.09,4.37l75.77,43.19a7.45,7.45,0,0,0,7.45,0c4.87-2.84,13.26-8,18.39-11.1A3.1,3.1,0,0,0,275,175c-15.32-8.91-65.32-38-76.27-44.34A4.12,4.12,0,0,0,194.45,130.75Z",
  fill: "#e1a621"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M195.58,166.44l26.47,14.89a2.64,2.64,0,0,1,0,4.59L206.53,195a3.51,3.51,0,0,1-3.52,0L175.92,179.6a2.21,2.21,0,0,1,0-3.84l16.19-9.3A3.51,3.51,0,0,1,195.58,166.44Z",
  fill: "#e1a621"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M194.45,130.75,173.34,143.9a2.55,2.55,0,0,0,.09,4.37l75.77,43.19a7.45,7.45,0,0,0,7.45,0c4.87-2.84,13.26-8,18.39-11.1A3.1,3.1,0,0,0,275,175c-15.32-8.91-65.32-38-76.27-44.34A4.12,4.12,0,0,0,194.45,130.75Z",
  fill: "#053855",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M195.58,166.44l26.47,14.89a2.64,2.64,0,0,1,0,4.59L206.53,195a3.51,3.51,0,0,1-3.52,0L175.92,179.6a2.21,2.21,0,0,1,0-3.84l16.19-9.3A3.51,3.51,0,0,1,195.58,166.44Z",
  fill: "#053855",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M194.07,78.26a17.88,17.88,0,0,0-2.56-1.55c-2.63-1.34-3.42-2.8-2.35-5.58,2.15-5.61-5.73-16.06-12-13.57-4,1.6-7.27,6.1-8.58,10.1a9.39,9.39,0,0,0-.24,5.36c.41,1.47,2.19,3,.5,4.17-2.88,2.08-7.32,2.88-8.36,6.8a4,4,0,0,0,.43,3.2,5.07,5.07,0,0,0,3.55,2c2.45.39,1.66.7,1.11,2.64-1.54,5.4,3.88,7,8.16,7.55,5.33.65,11.91,1.23,16.86-1.3,1.49-.76,2.9-2,3-3.77s-2.76-3.57-2-5.48a2.89,2.89,0,0,1,1-1.12c1.47-1.21,3.44-2.2,4-4.17C197.07,81.22,195.76,79.52,194.07,78.26Z",
  fill: "#96d88d"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M194.07,78.27a17.88,17.88,0,0,0-2.56-1.55c-2.63-1.34-3.42-2.8-2.35-5.58s-.37-6.85-2.87-9.86a7.53,7.53,0,0,1,.08,2.57c-.55,4-8.13,9.6-4.5,12.87,2.26,2,11.7,4,6.41,8.61-1.76,1.53-4.51,1.71-3.23,4.76.55,1.31,2.14,2.07,2.79,3.36.91,1.81.82,3.19-.75,4.59a8.6,8.6,0,0,1-5,1.84A19.68,19.68,0,0,0,190.61,98c1.49-.76,2.9-2,3-3.77s-2.76-3.57-2-5.48a2.89,2.89,0,0,1,1-1.12c1.47-1.21,3.44-2.2,4-4.17C197.07,81.23,195.76,79.53,194.07,78.27Z",
  fill: "#7ec971"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M175.58,92.6c-2.57-2.45-6.08-3.07-9.5-2.94a.54.54,0,0,1,.07.26.55.55,0,0,1,0,.24v.06l0,0c3.26-.12,6.61.43,9.06,2.77a13.49,13.49,0,0,1,3.6,6.86h.62A14.16,14.16,0,0,0,175.58,92.6Z",
  fill: "#378729"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M182.38,94.43q-.55.78-1,1.6c.16-2,.33-3.9.55-5.85a23.48,23.48,0,0,1,1.6-4,16.72,16.72,0,0,1,3.69-4.87,19.27,19.27,0,0,1,6.41-3.41,5.59,5.59,0,0,1-.51-.32l-.16-.08c-4,1.55-7.26,3.67-9.5,7.53a21.2,21.2,0,0,0-1.21,2.45c.17-1.28.35-2.57.56-3.84,1-6,2.64-12,6.43-16.77a6.41,6.41,0,0,1-.19-.72c-3.93,4.8-5.73,10.81-6.75,16.85-.4,2.36-.72,4.74-1,7.13v0q.55-16.3-.18-32.61a6.47,6.47,0,0,1-.61-.23q.67,14.73.27,29.48a.53.53,0,0,0-.33.21c-.18-1.58-.42-3.15-.75-4.7-1.3-6.17-4.07-13.92-10.35-16.59h0l-.08.14-.17.41c6.42,2.77,9,10.93,10.23,17.25a53,53,0,0,1,.78,6.7q-.26,3.33-.37,6.66A40.57,40.57,0,0,0,176.9,87c-1.63-3.62-4.79-8.72-9.15-9.13a8.7,8.7,0,0,1-1.3.62c5.41-.77,9.09,6.4,10.66,10.58a49.14,49.14,0,0,1,2.5,10.8h.07a151.48,151.48,0,0,0,1.31,22c.08.63,1.08.64,1,0a151.47,151.47,0,0,1-1.31-22h.42c0-.77.09-1.54.15-2.31a21.18,21.18,0,0,1,1.11-2,14.52,14.52,0,0,1,4.73-4.91,14.21,14.21,0,0,1,4.43-1.54,1.55,1.55,0,0,1,.25-.66,16,16,0,0,0-4.54,1.44A13.94,13.94,0,0,0,182.38,94.43Z",
  fill: "#378729"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.03,
  cy: 117.61,
  rx: 8.01,
  ry: 7.23,
  transform: "translate(-3.34 5.29) rotate(-1.67)",
  fill: "#ffb339"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M179,124.82c-5.45-3.54-2.3-11.64,3.46-14.06a8.76,8.76,0,0,0-2.65-.33c-4.42.13-7.91,3.47-7.8,7.46C172.13,121.5,175.16,124.4,179,124.82Z",
  fill: "#ffa522"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M240.89,103.78c9.85,5.55,31.81,18.29,40.14,23.13a4.57,4.57,0,0,1,2,5.5l-.16.44a4.52,4.52,0,0,1-6.52,2.39L236.13,112a4.71,4.71,0,0,1-2.06-5.72h0A4.77,4.77,0,0,1,240.89,103.78Z",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 244.88,
  cy: 111.98,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(92.44 333.94) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 249.87,
  cy: 114.92,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(93.68 341.29) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 254.88,
  cy: 117.87,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(94.92 348.67) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 260.11,
  cy: 120.92,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(96.25 356.36) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 265.35,
  cy: 124.03,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(97.52 364.08) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 270.56,
  cy: 127.02,
  rx: 2.16,
  ry: 1.82,
  transform: "translate(98.88 371.69) rotate(-80.09)",
  fill: "#33bdd3"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 264.7,
  cy: 94.58,
  rx: 10.19,
  ry: 9.48,
  transform: "translate(125.99 339.07) rotate(-80.09)",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 265.28,
  cy: 93.28,
  rx: 3.93,
  ry: 3.43,
  transform: "matrix(0.28, -0.96, 0.96, 0.28, 101.12, 321.6)",
  fill: "#33bdd3"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M255.83,98.44s3.23-3.57,7.65-2.15a6.49,6.49,0,0,1,4.36,7.8s-3.53,2.29-8.26-.81C259.58,103.29,256.42,101.27,255.83,98.44Z",
  fill: "#33bdd3"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M233,114.8a19.26,19.26,0,0,0,3-.76c1.08-.43-2.78-1.17-2.78-1.17",
  fill: "#1ca9b7"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M223.38,87.56a8.16,8.16,0,0,1,4-.9c1.88.2-.24,4-.24,4",
  fill: "#1ca9b7"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M228.67,87.08l12.4,7.4A3,3,0,0,1,242.37,98l-4.59,13.8c-.61,1.82-2,3-3.64,2l-13.31-7.09a3,3,0,0,1-1.29-3.49l4.75-14.49A3,3,0,0,1,228.67,87.08Z",
  fill: "#1ca9b7"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M226.12,87.73l12.4,7.4a3,3,0,0,1,1.31,3.52l-4.59,13.8c-.61,1.82-2,3-3.64,2l-13.31-7.09a3,3,0,0,1-1.29-3.49l4.75-14.49A3,3,0,0,1,226.12,87.73Z",
  fill: "#33bdd3"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M229,88.36s2-8,7.1-6.77,1,11.49,1,11.49,0,1,2.33,1.37c0,0,5-12-1.76-15.17s-10.61,6.21-11,7.92A2.27,2.27,0,0,0,229,88.36Z",
  fill: "#ebeded"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 228.58,
  cy: 98.04,
  rx: 3.28,
  ry: 3.59,
  transform: "matrix(0.99, -0.14, 0.14, 0.99, -11.3, 32.34)",
  fill: "#ebeded"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 225.75,
  y: 95.71,
  width: 3.12,
  height: 11.5,
  rx: 1.24,
  ry: 1.24,
  transform: "translate(45.86 -68.95) rotate(19.15)",
  fill: "#ebeded"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M163.13,204.26l-1.07-.81.95-12.69,5.58.2s-.28,5.42.91,6.75,4.55.68,4.86.81,2.55-.35,3.46.74-3.63,3.69-6,4.06a14.87,14.87,0,0,1-4.79-.16s-.26-3.28-1.08-3-1.13,3.69-1.13,3.69Z",
  fill: "#9c4100"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M160.84,164.32c-.46,13.27-.95,30.56-.95,30.56s3,4.12,11.25,2.36c.88-.19,2.84-21.34,3.8-32.34A31.56,31.56,0,0,0,160.84,164.32Z",
  fill: "#7ec971"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M177.68,215.16l-1.07-.81.95-12.69,5.58.2s-.28,5.42.91,6.75,4.55.68,4.86.81,2.55-.35,3.46.74-3.63,3.69-6,4.06a14.87,14.87,0,0,1-4.79-.16s-.26-3.28-1.08-3-1.13,3.69-1.13,3.69Z",
  fill: "#053855"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M180.08,166.73a33.26,33.26,0,0,0-11.63-2.9c.68,5,1.31,8.41,1.42,8.66.27.63,5.38,32.16,5.38,32.16,6,2.43,13.16.4,13.16.4s-2.46-24.6-2.66-28.71q0-.66-.07-1.33A9.67,9.67,0,0,0,180.08,166.73Z",
  fill: "#7ec971"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M143,174.06s10.22-9.25,17.84-9.74,18.45,7.41,17.6,12S163,190.77,163,190.77",
  fill: "#7ec971"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M163.9,157.55l-8.14-5.76a1.73,1.73,0,0,1-.58-2.12l5.77-12.83a1.73,1.73,0,0,1,2.49-.76l9.1,5.67a1.73,1.73,0,0,1,.62,2.27l-6.73,12.91A1.73,1.73,0,0,1,163.9,157.55Z",
  fill: "#1784aa"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M163.17,157.1,155,151.34a1.73,1.73,0,0,1-.58-2.12l5.77-12.83a1.73,1.73,0,0,1,2.49-.76l9.1,5.67a1.73,1.73,0,0,1,.62,2.27l-6.73,12.91A1.73,1.73,0,0,1,163.17,157.1Z",
  fill: "#29abe2"
});

var _ref46 = /*#__PURE__*/React.createElement("polygon", {
  points: "164.53 156.31 155.37 149.84 161.38 136.48 171.56 142.82 164.53 156.31",
  fill: "#e4f5fd"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M160.29,142.15c-3,1.66-7.77,3.55-11,5.75-.51.35-1.27,1.57-.77,1.39-.22.25,1.87,1.07,1.67,1.34-.06.09,1.35-.69,1.43-.66h0a5.46,5.46,0,0,0,3.91.47l.53-.39,0,0,.13-.08a.31.31,0,0,1,.09-.1l.08-.06a.31.31,0,0,1,.12-.19c.7-.55,2.24-.84,2.4-1.77a1.91,1.91,0,0,0-.22-.7.27.27,0,0,1,.06-.36,2.13,2.13,0,0,0-.31-1.62l0,0,.18-.21A20.5,20.5,0,0,0,161,143a.48.48,0,0,0,.15-.29v-.05a.44.44,0,0,0,0-.09A.57.57,0,0,0,160.29,142.15Z",
  fill: "#e85454"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M158.75,145.43c-.23-.58-.56-.61-1.09-.38a18.26,18.26,0,0,0-3,1.72c-.16.11,0,.36.16.26.59-.4,3.15-2.29,3.67-1.46s-1.2,1.4-1.68,1.65l-1.84,1c-.17.09,0,.35.16.26l1.18-.61a.15.15,0,0,0,0,.09,1.79,1.79,0,0,0,.35.35,1.13,1.13,0,0,0-.13,1.05l.05.06a3.29,3.29,0,0,1-4,.58c-.15-.11-.36.1-.21.22,1.2.9,3.68.64,4.52-.69a1.64,1.64,0,0,0,.54-.17,3.54,3.54,0,0,0,1.43-.93,1.19,1.19,0,0,0,0-1.21l0-.05a.75.75,0,0,0,0-1.08A1.14,1.14,0,0,0,158.75,145.43Zm-.13,2.72a1.91,1.91,0,0,1-.78.63c-.19.11-.67.45-.86.4-.39-.1-.15-.61,0-.83h0a2.11,2.11,0,0,0,.59-.35l.73-.46.24-.18A.93.93,0,0,1,158.62,148.15Zm-.94-.56c-.42.26-.76.59-1.15.12.59-.3,1.18-.6,1.73-.95a1.4,1.4,0,0,0,.43-.39C159,146.9,158,147.39,157.68,147.59Z",
  fill: "#653200"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M151.23,145.61s2,.46,2.2,4.75l-1.53,3.81-8.33-4.32S145.56,147.35,151.23,145.61Z",
  fill: "#88d3d8"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M171,147.62c-.62,1.37-1.24,2.61-1.76,4-.38-.93-.73-1.69-1.2-2.58a.68.68,0,0,0-.07-.09.72.72,0,0,0-1.33.44,5.82,5.82,0,0,0,1,2.36.73.73,0,0,0-.19.14c-1.2,1.33-.91,3.37-.77,5a.63.63,0,0,0,.95.51.64.64,0,0,0,.32-.08,5.39,5.39,0,0,0,2.17-3.12C170.79,152.13,171.67,149.83,171,147.62Z",
  fill: "#e85454"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M139.88,147.51l3-.9c.75.11,7.26,2.77,10,7.41a29,29,0,0,1,.66,4.3c.25,1.93.45,3.87.54,5.81a42.34,42.34,0,0,1-.1,6.35c-.09.9-.15,1.36-.31,2.25a4,4,0,0,1-1.18.71c-9,3.13-15.66-1.94-15.93-2.68s-.7-11.14-.92-17.34A6,6,0,0,1,139.88,147.51Z",
  fill: "#88d3d8"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M147.85,136.78s2,10.2-1.73,11.3-8.18-3.15-8.5-5.25S142.58,133.38,147.85,136.78Z",
  fill: "#e85454"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M146.39,140.86c.11-.17,2.28-.74,2.73-2.56s-1.19-4.21-4.95-4.55-10.07,1.71-9.1,11.61S146,151,146.65,147.84A19,19,0,0,0,146.39,140.86Z",
  fill: "#653200"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M146.39,140.86s.63,3.38,2,4.84,2.48,4.1.8,6.12,0,3.11,2.37,5,.91,9.78-7.66,7.85-12.61-7.1-12.61-7.1,2.2-15.42,4.54-19",
  fill: "#653200"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M152.88,154.17s1.94,6.5,3.88,6.7,4.88-2.67,6.95-6.42a5.44,5.44,0,0,1,6,5.21s-6.83,13.84-16.79,10.46",
  fill: "#88d3d8"
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 163.46,
  cy: 146.01,
  rx: 4,
  ry: 3.44,
  transform: "translate(-31.93 245.32) rotate(-68.71)",
  fill: "#1784aa"
});

var _ref57 = /*#__PURE__*/React.createElement("polygon", {
  points: "161.14 145 162.21 144.67 162.66 146.19 166.16 144.94 166.32 146.01 162.06 147.57 161.14 145",
  fill: "#e4f5fd"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M117.11,203.74c-6.12-7.63-8.93-17.4-8.81-27.17A31,31,0,0,1,117,155.36c5.05-5.18,12.67-7.73,19.43-4.22,5.61,2.91,8.33,8.5,10.28,14.23,2.34,6.86,3.13,15.65,11.49,17.77,3.24.82,6.65.26,10,0,5.82-.4,12,1.49,13.76,7.69,3.24,11.1-11.69,20.58-20.08,24.16a38.78,38.78,0,0,1-43-9.3Q117.93,204.76,117.11,203.74Z",
  fill: "#ffde47"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M181.62,191c-5.94,10.74-25.27,15.58-35.81,15-9.57-.49-15.62-6.33-15-16,.36-5.32,2-10.62,1.57-16-.81-9.12-9.47-16.61-18.31-14.83a31.21,31.21,0,0,0-5.91,18c-.12,9.77,2.68,19.53,8.81,27.17q.82,1,1.71,2a38.78,38.78,0,0,0,43,9.3c8.4-3.58,23.32-13.06,20.08-24.16C181.74,191.31,181.67,191.16,181.62,191Z",
  fill: "#fcc62d"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M93.07,72.16l.76,41.91a2.64,2.64,0,0,0,3.81,2.31l35.61-17.74a3.49,3.49,0,0,0,1.93-3.19l-.76-41.93A2.85,2.85,0,0,0,130.28,51L95,69A3.49,3.49,0,0,0,93.07,72.16Z",
  fill: "#e1a621"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M129,78.51C122.22,80.43,124.57,88,119.7,92c-5.93,4.87-8.17-9-15.45-8.08-8.73,1-10.42,30.2-10.42,30.2,1.38,3.31,3.81,2.31,3.81,2.31l37.59-18.73-.29-16.13C133.36,79.69,131.41,78.27,129,78.51Z",
  fill: "#053855",
  opacity: 0.3
});

var SvgAuthentication = function SvgAuthentication(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 400 300",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuthentication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/authentication.222c4b74.svg";
export { ForwardRef as ReactComponent };